import { useState } from 'react';
import Cookies from "js-cookie";

const submitForm = ({ formId, portalId = '7026924', setIsSubmitted }) => {
  const isBrowser = typeof window !== "undefined";
  const postUrl = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  return {
    error,
    response,
    loading,
    post: async (values) => {
      try {
        setLoading(true);
        setError(null);
        setResponse(null);

        if (formId === '070c7fb5-f573-4378-b9fb-0b0c1be1551b') {
          if (
            values.email === '' ||
            values.firstname === '' ||
            values.lastname === '' ||
            values.property_address === '' ||
            values.phone === '' ||
            values.of_properties === '' ||
            values.number_of_bedrooms === ''
          ) {
            setLoading(false);
            return null;
          }
        }

        const hutk = isBrowser ? Cookies.get("hubspotutk") : null;
        const pageUri = isBrowser ? window.location.href : null;
        const pageName = isBrowser ? document.title : null;
        const pageUrl = isBrowser ? window.location.pathname : null;

        const fields = Object.keys(values).map((key) => ({
          name: key,
          value: values[key],
        }));

        const data = {
          fields,
          context: {
            hutk,
            pageUri,
            pageName,
          },
        };

        console.log('HubSpot URL:', postUrl);
        console.log('HubSpot payload:', data);

        const res = await fetch(postUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });

        const text = await res.text();

        console.log('HubSpot status:', res.status);
        console.log('HubSpot response:', text);

        const result = {
          ok: res.ok,
          status: res.status,
          body: text,
        };

        setResponse(result);

        if (!res.ok) {
          throw new Error(`HubSpot error ${res.status}: ${text}`);
        }

        if (typeof setIsSubmitted !== 'undefined') {
          setIsSubmitted(true);
        }

        if (typeof window?.dataLayer?.push !== 'undefined') {
          window.dataLayer.push({ event: 'form-submit', pageUrl });
        }

        return result;
      } catch (err) {
        console.log('HubSpot submit failed:', err);
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
  };
};

export default submitForm;